import { render, staticRenderFns } from "./RequestgroupsList.vue?vue&type=template&id=e15773ec&scoped=true&"
import script from "./RequestgroupsList.vue?vue&type=script&lang=js&"
export * from "./RequestgroupsList.vue?vue&type=script&lang=js&"
import style0 from "./RequestgroupsList.vue?vue&type=style&index=0&id=e15773ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15773ec",
  null
  
)

export default component.exports